export default {
  heading: '"Spline Sans Variable", -apple-system, system-ui, sans-serif',
  body: '"Open Sans Variable", -apple-system, system-ui, sans-serif'
}
